import React from 'react'
import ViewReAuditUi from './ViewReAuditUi'

function ViewReAudit({handleCloseModal,viewReAuditData}) {
    
  return (
   <ViewReAuditUi handleCloseModal={handleCloseModal} data={viewReAuditData}/>
  )
}

export default ViewReAudit